import laptop from "./laptop";
import phone from "./phone";
import Zigzaga from "./zigzaga";

const svgs = {
    Zigzaga,
    laptop,
    phone
}

export default svgs;